var _Path, _Text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Text } from "react-native-svg";
var SvgReportAbusive = function SvgReportAbusive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF4D3D",
    d: "M6 3h12a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H9.6l-4.8 4 .6-4C3.5 16.7 2 15 2 13V7a4 4 0 0 1 4-4"
  })), _Text || (_Text = /*#__PURE__*/React.createElement(Text, {
    x: 12,
    y: 13.2,
    fill: "#0F0301",
    fontFamily: "Sofia Sans",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: 0.2,
    textAnchor: "middle"
  }, "#*!")));
};
export default SvgReportAbusive;